"use strict";module.exports=function(o,r,i,n){if(!(o instanceof r)||void 0!==n&&n in o)throw TypeError(i+": incorrect invocation!");return o};